import { createRouter, createWebHistory } from 'vue-router'

declare module 'vue-router' {
  interface RouteMeta {
    tab?: 'home' | 'tasks' | 'scan' | 'orders' | 'profile'
    hideNav?: boolean
    title?: string
  }
}

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  // 滚动容器是设备 viewport(非 window),位置记忆与置顶由 MobileAppShell 统一管理
  scrollBehavior: () => false,
  routes: [
    { path: '/', redirect: '/home' },
    {
      path: '/home',
      name: 'mobile-home',
      component: () => import('@/features/home/MobileHomeView.vue'),
      meta: { tab: 'home', title: '今日工作台' },
    },
    {
      path: '/tasks',
      name: 'mobile-tasks',
      component: () => import('@/features/tasks/MobileTasksView.vue'),
      meta: { tab: 'tasks', title: '履约任务' },
    },
    {
      path: '/scan',
      name: 'mobile-scan',
      component: () => import('@/features/scan/MobileScanView.vue'),
      meta: { tab: 'scan', title: '扫码与 RFID 对账' },
    },
    {
      path: '/orders',
      name: 'mobile-orders',
      component: () => import('@/features/orders/MobileOrdersView.vue'),
      meta: { tab: 'orders', title: '订单' },
    },
    {
      path: '/orders/:orderId',
      name: 'mobile-order-detail',
      component: () => import('@/features/orders/MobileOrderDetailView.vue'),
      meta: { tab: 'orders', hideNav: true, title: '订单详情' },
    },
    {
      path: '/intake',
      name: 'mobile-intake',
      component: () => import('@/features/intake/MobileIntakeView.vue'),
      meta: { hideNav: true, title: '移动收衣' },
    },
    {
      path: '/qc/:orderId?',
      name: 'mobile-qc',
      component: () => import('@/features/qc/MobileQcView.vue'),
      meta: { tab: 'tasks', hideNav: true, title: '工厂二次自检' },
    },
    {
      path: '/notifications',
      name: 'mobile-notifications',
      component: () => import('@/features/notifications/MobileNotificationsView.vue'),
      meta: { tab: 'home', hideNav: true, title: '消息' },
    },
    {
      path: '/profile',
      name: 'mobile-profile',
      component: () => import('@/features/profile/MobileProfileView.vue'),
      meta: { tab: 'profile', title: '我的' },
    },
    { path: '/:pathMatch(.*)*', redirect: '/home' },
  ],
})

router.afterEach((to) => {
  document.title = `${String(to.meta.title ?? '移动履约端')} · 洗掌柜`
})
